import React from 'react';
import TermsOfUse from '../../../components/Mentions_legale/TermsOfUse/TermsOfUse';
import './TermsOfUsePage.scss';
import Footer from '../../../components/Footer/Footer';

function TermsOfUsePage() {
    return (
        <div className="terms-of-use-page">
            <header className="terms-of-use-header">
                <h1>Conditions d'utilisation</h1>
            </header>

            <main className="terms-of-use-main">
                <TermsOfUse useConditionsLink={false} />
            </main>

            <Footer />
        </div>
    );
}

export default TermsOfUsePage;
